import request from "utils/request";
import { baseRequestURL } from "api/BaseAPI";
import * as BlueprintAPI from "api/BlueprintAPI";

export const TYPES = {
  model: "MODEL",
  consulting: "CONSULTING"
};

const MODEL_PLACEHOLDER = [
  {
    id: 1,
    name: "Aible v2",
    created_by: { fullname: "Captain Aible" },
    wizard: {
      marketplace: {
        purchased: false,
        modelDetails: {
          price: 0,
          description: "Lorem Ipsum",
          rating: 4.1,
          reviews: 9
        }
      }
    }
  },
  {
    id: 2,
    name: "Super Secret Aible Model",
    created_by: { fullname: "Captain Aible" },
    wizard: {
      marketplace: {
        purchased: false,
        modelDetails: {
          price: 100,
          priceModifier: "/month",
          priceConditional: "if deployed",
          description: "Model Ipsum",
          rating: 4.8,
          reviews: 27,
          links: {
            blueprints: [
              { id: 321, created_by: { id: 18, fullname: "Aible Test" }, name: "Bank Direct Marketing" },
              { id: 189, created_by: { id: 18, fullname: "Aible Test" }, name: "Direct Marketing" }
            ],
            data: [{ id: 1, name: "US Marketing Spend", author: "Captain Aible" }]
          }
        }
      }
    }
  }
];

const DATA_PLACEHOLDER = [
  {
    id: 1,
    type: "data",
    name: "US Marketing Spend",
    author: "Captain Aible",
    purchased: false,
    details: {
      price: 500,
      priceModifier: "/week/model",
      description: "Data placeholder",
      rating: 4.2,
      reviews: 13,
      links: {
        blueprints: [
          { id: 321, created_by: { id: 18, fullname: "Aible Test" }, name: "Bank Direct Marketing" },
          { id: 189, created_by: { id: 18, fullname: "Aible Test" }, name: "Direct Marketing" }
        ],
        models: [{ id: 2, author: "Captain Aible", name: "Super Secret Aible Model" }]
      }
    }
  },
  {
    id: 2,
    type: "data",
    name: "Marketing Data Recipe",
    author: "Captain Aible",
    purchased: false,
    details: {
      price: 199.99,
      priceConditional: "if result is deployed",
      description: "Data Mapping as a recipe",
      rating: 3.2,
      reviews: 9,
      links: {
        models: [
          { id: 1, author: "Captain Aible", name: "Aible v2" },
          { id: 2, author: "Captain Aible", name: "Super Secret Aible Model" }
        ]
      }
    }
  },
  {
    id: 3,
    type: "data",
    name: "Marketing Data Cleansing",
    author: "Captain Aible",
    purchased: false,
    details: {
      price: 499.99,
      priceModifier: " per dataset",
      description: "Data cleansing for your business' data",
      rating: 4.2,
      reviews: 2
    }
  }
];

const CONSULTING_PLACEHOLDER = {
  1: {
    id: 1,
    type: "consulting",
    name: "DRG Code data cleansing",
    author: "Captain Aible",
    purchased: false,
    details: {
      price: 99.99,
      priceConditional: "if results improve by > 1%",
      description: "consulting placeholder",
      rating: 5.0,
      reviews: 36,
      links: {
        blueprints: [{ id: 321, created_by: { id: 18, fullname: "Aible Test" }, name: "Bank Direct Marketing" }],
        models: [
          { id: 1, author: "Captain Aible", name: "Aible v2" },
          { id: 2, author: "Captain Aible", name: "Super Secret Aible Model" }
        ],
        data: [{ id: 1, name: "US Marketing Spend", author: "Captain Aible" }]
      }
    }
  }
};

export function getModels() {
  /* These should be changed to match whatever models we're adding/removing 
		Model id is the id of the model we want to delete/undelete
		name is stored under the blueprint name
	*/

  return new Promise(function (resolve, reject) {
    resolve(MODEL_PLACEHOLDER);
  });
}

export function getData() {
  return new Promise(function (resolve, reject) {
    resolve(DATA_PLACEHOLDER);
  });
}

export function getConsulting() {
  return new Promise(function (resolve, reject) {
    resolve(CONSULTING_PLACEHOLDER);
  });
}

export function activateModel(id) {
  return request(baseRequestURL + "v1/model/setDeleted", {
    method: "POST",
    body: JSON.stringify({
      model_id: id,
      deleted: "not_deleted"
    })
  }).then((response) => response);
}

export function deactivateModel(id) {
  return request(baseRequestURL + "v1/model/setDeleted", {
    method: "POST",
    body: JSON.stringify({
      model_id: id,
      deleted: "deleted"
    })
  }).then((response) => response);
}

export function createModel(id, name, data) {
  data.setup = { label: name };
  const marketplace = data.marketplace || {};
  !marketplace.modelDetails && (marketplace.modelDetails = {});
  marketplace.modelDetails.id = id;
  data.type = TYPES.model;
  /* Activate this Model (for hookup) */
  // return activateModel(id).then(
  // 	res => BlueprintAPI.createBlueprint(data)
  // )
  return BlueprintAPI.createBlueprint(data);
}

export function createConsulting(name, data) {
  const wizard = {
    setup: { label: name },
    type: TYPES.consulting,
    marketplace: {
      purchased: false,
      consultingDetails: data
    }
  };
  return BlueprintAPI.createBlueprint(wizard);
}

export function updateConsulting(id, data) {
  return BlueprintAPI.updateBlueprint(id, data);
}
